import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { StateService } from '@/core/services/state.service';
import { AnfrageService, PhaseService } from '@/api/service-index';
import { AnfrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageTransformerService } from '@/core/services/anfrage-transformer.service';
import { PhaseDisplayModel } from '@/api/model-index';

@Injectable({
    providedIn: 'root'
})
export class GetAenderungsantragAnfrageByIdResolver  {
    constructor(protected anfrageService: AnfrageService, protected stateService: StateService, protected portalContextService: PortalContextService, protected phaseService: PhaseService, protected anfrageTransformerService: AnfrageTransformerService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AnfrageDisplayModel | undefined> {
        let id: string = <string>route.params['id'];

        this.stateService.IsEndvalidationEnabled = false;

        let anfrage: AnfrageDisplayModel;

        if (this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id === id) {
            anfrage = this.portalContextService.CurrentAnfrage;
        }
        else {
            anfrage = await this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: id }).toPromise();
            this.portalContextService.CurrentAnfrage = anfrage;
        }

        if (!anfrage.aenderungsantragsPhaseId)
            throw new Error('AenderungsantragsPhaseId is not set on AnfrageDisplayModel');
        
        let phase: PhaseDisplayModel;
        if (this.portalContextService.AenderungsantragsPhase) {
            phase = this.portalContextService.AenderungsantragsPhase;
        }
        else {
            phase = await this.phaseService.apiPhasePhaseIdGet({ phaseId: anfrage.aenderungsantragsPhaseId }).toPromise();
            this.portalContextService.AenderungsantragsPhase = phase;
        }

        anfrage.phase!.abschnitte = phase.abschnitte;
        
        const transformedAnfrage = await this.anfrageTransformerService.transform(anfrage);

        this.portalContextService.CurrentAnfrage = transformedAnfrage;

        return transformedAnfrage;
    }
}
